import React, { useCallback, useState } from 'react';
import EditableField from 'src/components/fields/EditableField';
import { Input } from 'antd';

export interface TextareaEditableFieldProps {
  value: string;
  placeholder?: string;
  className?: string;
  onEditModeChange?: (e: boolean) => void;
  onBlur?: (e: string | undefined) => void;
}

const TextareaEditableField: React.FC<TextareaEditableFieldProps> = (props: TextareaEditableFieldProps) => {
  const { value, onBlur, onEditModeChange, className, placeholder } = props;
  const [innerValue, setInnerValue] = useState<string>(value);
  const submit = useCallback(() => {
    if (value !== innerValue) {
      onBlur && onBlur(innerValue);
    }
  }, [innerValue, onBlur, value]);
  return (
    <EditableField value={value || '-'} onEditModeChange={onEditModeChange} className={className}>
      <Input.TextArea
        autoFocus
        value={innerValue}
        placeholder={placeholder}
        onChange={e => setInnerValue(e.target.value)}
        onBlur={() => submit()}
      />
    </EditableField>
  );
};

export default TextareaEditableField;
